import * as React from "react";
import {connect} from "react-redux";
import * as selectors from "../selectors";
import DownloadState from "../DownloadState";
import {Radio, Form} from 'react-bootstrap';
import {Destination} from "../../../../integration/representation/contract";
import {
    setDestination,
    SetDestination
} from "../actions";

interface TagProps {
}

interface DispatchProps {
    doSetDestination: SetDestination
}

interface StateProps {
    destination: Destination;
}

type Props = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: DownloadState): StateProps => {
    return {
        destination: selectors.destination(state),
    };
};

const mapDispatchToProps: DispatchProps = ({
    doSetDestination: setDestination
});


class Component extends React.Component<Props, {}> {

    handleDestinationSelection(e: any, destination: any) {
        this.props.doSetDestination(destination);
    }

    render() {
        let { destination } = this.props;

        return (
            <div className={"download-selection-box"}>
                <h2>Destinasjon</h2>
                <p>Jeg vil laste ned SOSI-fil med objekter som skal til:</p>
                <Form>
                    <Radio
                        checked={destination === "NVDB"}
                        onChange={(e) => this.handleDestinationSelection(e, "NVDB")}
                    >
                        NVDB
                    </Radio>
                    <Radio
                        checked={destination === "FKB"}
                        onChange={(e) => this.handleDestinationSelection(e, "FKB")}
                        >
                        FKB
                    </Radio>
                </Form>
            </div>
        )
    }
}

export const DestinationSelection = connect(mapStateToProps, mapDispatchToProps)(Component);
